import { MapPin } from "lucide-react";
import CitySelectorForm from "../inputs/CitySelectorForm";
import AddressDropdown from "../inputs/AddressDropdown";

interface DepartureSectionProps {
  formData: any;
  setFormData: (data: any) => void;
  handleDepartureLocationChange: (location: any) => void;
  handleDepartureCityChange: (city: any) => void;
}

const DepartureSection: React.FC<DepartureSectionProps> = ({
  formData,
  setFormData,
  handleDepartureLocationChange,
  handleDepartureCityChange
}) => {
  if (!formData.plecare_separata) {
    return null;
  }

  return (
    <div className="bg-gradient-to-r from-green-50 to-emerald-50 rounded-xl p-4 border border-green-200 shadow-sm">
      <div className="flex items-center mb-3">
        <div className="p-2 bg-green-500 rounded-lg mr-3">
          <MapPin className="w-4 h-4 text-white" />
        </div>
        <h3 className="font-semibold text-gray-800 text-lg">Locație Plecare</h3>
      </div>

      <div className="space-y-3">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Oraș plecare *
          </label>
          <CitySelectorForm
            selectedCity={formData.oras_plecare || ""}
            onCityChange={handleDepartureCityChange}
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Adresa plecare *
          </label>
          <AddressDropdown
            value={formData.locatie_plecare_id ? {
              id: formData.locatie_plecare_id,
              adresa: formData.adresa_plecare || '',
              oras: formData.oras_plecare,
              tara: 'Romania',
              tip: 'plecare'
            } : null}
            onChange={handleDepartureLocationChange}
            city={formData.oras_plecare || ''}
            type="plecare"
            placeholder="Caută sau adaugă adresa de plecare"
            required={formData.plecare_separata}
          />
        </div>

        
      </div>
    </div>
  );
};

export default DepartureSection;